// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file mission/v1/guarantee.proto (package mission.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mission/v1/guarantee.proto.
 */
export const file_mission_v1_guarantee: GenFile = /*@__PURE__*/
  fileDesc("ChptaXNzaW9uL3YxL2d1YXJhbnRlZS5wcm90bxIKbWlzc2lvbi52MSJWChJHdWFyYW50ZWVXaXRoTGFiZWwSMQoOZ3VhcmFudGVlX3R5cGUYASABKA4yGS5taXNzaW9uLnYxLkd1YXJhbnRlZVR5cGUSDQoFbGFiZWwYAiABKAkiFgoUTGlzdEd1YXJhbnRlZVJlcXVlc3QiVQoVTGlzdEd1YXJhbnRlZVJlc3BvbnNlEjwKFGF2YWlsYWJsZV9ndWFyYW50ZWVzGAEgAygLMh4ubWlzc2lvbi52MS5HdWFyYW50ZWVXaXRoTGFiZWwqxgEKDUd1YXJhbnRlZVR5cGUSHgoaR1VBUkFOVEVFX1RZUEVfVU5TUEVDSUZJRUQQABIfChtHVUFSQU5URUVfVFlQRV9SRVBBVFJJQVRJT04QARInCiNHVUFSQU5URUVfVFlQRV9KT1VSTkVZX0NPTlRJTlVBVElPThACEiMKH0dVQVJBTlRFRV9UWVBFX1ZFSElDTEVfUkVDT1ZFUlkQAxImCiJHVUFSQU5URUVfVFlQRV9SRVBMQUNFTUVOVF9WRUhJQ0xFEARCPlo8Z2l0aHViLmNvbS90aGV0cmVlcC9hNnRyL2JhY2tlbmQvZ2VuL2dvL21pc3Npb24vdjE7bWlzc2lvbnYxYgZwcm90bzM");

/**
 * GuaranteeWithLabel - a GuaranteeType paired with its display label.
 *
 * @generated from message mission.v1.GuaranteeWithLabel
 */
export type GuaranteeWithLabel = Message<"mission.v1.GuaranteeWithLabel"> & {
  /**
   * @generated from field: mission.v1.GuaranteeType guarantee_type = 1;
   */
  guaranteeType: GuaranteeType;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message mission.v1.GuaranteeWithLabel.
 * Use `create(GuaranteeWithLabelSchema)` to create a new message.
 */
export const GuaranteeWithLabelSchema: GenMessage<GuaranteeWithLabel> = /*@__PURE__*/
  messageDesc(file_mission_v1_guarantee, 0);

/**
 * ListGuaranteeRequest - empty request for listing available GUARANTEES (guarantee types) for Mission creation.
 *
 * @generated from message mission.v1.ListGuaranteeRequest
 */
export type ListGuaranteeRequest = Message<"mission.v1.ListGuaranteeRequest"> & {
};

/**
 * Describes the message mission.v1.ListGuaranteeRequest.
 * Use `create(ListGuaranteeRequestSchema)` to create a new message.
 */
export const ListGuaranteeRequestSchema: GenMessage<ListGuaranteeRequest> = /*@__PURE__*/
  messageDesc(file_mission_v1_guarantee, 1);

/**
 * ListGuaranteeResponse - response containing the data needed to populate the Mission creation form.
 *
 * @generated from message mission.v1.ListGuaranteeResponse
 */
export type ListGuaranteeResponse = Message<"mission.v1.ListGuaranteeResponse"> & {
  /**
   * @generated from field: repeated mission.v1.GuaranteeWithLabel available_guarantees = 1;
   */
  availableGuarantees: GuaranteeWithLabel[];
};

/**
 * Describes the message mission.v1.ListGuaranteeResponse.
 * Use `create(ListGuaranteeResponseSchema)` to create a new message.
 */
export const ListGuaranteeResponseSchema: GenMessage<ListGuaranteeResponse> = /*@__PURE__*/
  messageDesc(file_mission_v1_guarantee, 2);

/**
 * GuaranteeType - type of GUARANTEE (guarantee) that triggers a Mission.
 *
 * @generated from enum mission.v1.GuaranteeType
 */
export enum GuaranteeType {
  /**
   * @generated from enum value: GUARANTEE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GUARANTEE_TYPE_REPATRIATION = 1;
   */
  REPATRIATION = 1,

  /**
   * @generated from enum value: GUARANTEE_TYPE_JOURNEY_CONTINUATION = 2;
   */
  JOURNEY_CONTINUATION = 2,

  /**
   * @generated from enum value: GUARANTEE_TYPE_VEHICLE_RECOVERY = 3;
   */
  VEHICLE_RECOVERY = 3,

  /**
   * @generated from enum value: GUARANTEE_TYPE_REPLACEMENT_VEHICLE = 4;
   */
  REPLACEMENT_VEHICLE = 4,
}

/**
 * Describes the enum mission.v1.GuaranteeType.
 */
export const GuaranteeTypeSchema: GenEnum<GuaranteeType> = /*@__PURE__*/
  enumDesc(file_mission_v1_guarantee, 0);

